import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectNavigationContent } from 'redux/selector/app'
import { INDEX, PROFILE, CATEGORY, APP_CENTER, GAME, WATERFALL } from 'constant/routers'
import {
  NAV_TYPE_ACCOUNT,
  NAV_TYPE_APPLICATIONS,
  NAV_TYPE_DISCOVER,
  NAV_TYPE_NORMAL,
  NAV_TYPE_GAME,
  NAV_TYPE_WATERFALL,
} from 'constant/common'
import { getDebugInfo } from 'utils/debugUtil'

const NAV_MAP: Record<string, string> = {
  [NAV_TYPE_NORMAL]: INDEX,
  [NAV_TYPE_DISCOVER]: CATEGORY,
  [NAV_TYPE_GAME]: GAME,
  [NAV_TYPE_ACCOUNT]: PROFILE,
  [NAV_TYPE_APPLICATIONS]: APP_CENTER,
  [NAV_TYPE_WATERFALL]: WATERFALL,
  waterfall: WATERFALL,
}

const NAV_SHOW_DEBUG_WATERFLOW = getDebugInfo().includes('NAV_SHOW_DEBUG_WATERFLOW')

const navIconName: Record<number, string> = {
  1: 'nav/ic_home',
  2: 'nav/ic_hot',
  3: 'nav/ic_sex',
  4: 'nav/ic_game',
  5: 'nav/ic_discover',
}

export const useNavigationLocalData = () => {
  const navigationContent: any = useSelector(selectNavigationContent)

  const navContent = useMemo(() => {
    /** due to old version application support three navigation */
    const apiNavResponse = navigationContent
      ?.filter((e: any, i: number) => NAV_MAP[e.type] != null)
      ?.map(({ type, icon_id, name, icon_path, icon_path2, id }: any, index: number) => {
        return {
          id,
          name,
          search: index !== 0 && NAV_MAP[type] === INDEX ? `?nav_id=${id}` : '',
          imageName: navIconName[icon_id],
          dynamicIconActive: icon_path,
          dynamicIconInactive: icon_path2,
          navLink: NAV_MAP[type] ?? INDEX,
          type,
        }
      })

    if (!apiNavResponse || apiNavResponse.length === 0) {
      return []
    }

    return [
      ...apiNavResponse,
      ...(NAV_SHOW_DEBUG_WATERFLOW
        ? [
            {
              id: 'waterfall',
              name: 'Waterfall',
              search: '',
              imageName: 'nav/ic_hot',
              navLink: WATERFALL,
              type: 'waterfall',
            },
          ]
        : []),
    ]
  }, [navigationContent])

  return {
    navContent,
  }
}
